import { useQuery } from '@tanstack/react-query';

import client from './client';
import { QUERY_KEYS } from './query-keys';

import type { UseQueryOptions } from '@tanstack/react-query';

export const useInvoice = (
  { invoiceId }: { invoiceId: string },
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof client.fetchChainStoreInvoice>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.INVOICE, invoiceId],
    queryFn: () => client.fetchChainStoreInvoice({ invoiceId }),
    ...options,
  });

  const invoice = query.data?.data?.data ?? null;
  const merchant = query.data?.data?.merchant ?? null;

  return {
    invoice,
    merchant,
    ...query,
  };
};
